import * as React from "react";
import { css } from "@emotion/core";
import {
  Button,
  Navbar,
  NavbarGroup,
  NavbarHeading,
  EditableText,
  Icon,
} from "@blueprintjs/core";
import { IAnnotationFields } from "interfaces";
import ApiAnnotations from "api/annotations";
import ApiLayers from "api/layers";
import { CheckEditAccess } from "context/";
import Annotation from "models/Annotation";

const InspectorHeader = ({
  model,
  closeInspector = null,
  onDelete = null,
  sub = false,
}) => {
  const [name, setName] = React.useState(model.label);

  const updateMethod =
    model.class.name === "Annotation"
      ? ApiAnnotations.updateAnnotation
      : ApiLayers.updateAnnotationLayer;

  const updateToField =
    (field: string) =>
    (value: any): Promise<any> => {
      const fields: IAnnotationFields = { [field]: value };

      return updateMethod(model.id, fields);
    };

  React.useEffect(() => {
    setName(model.label);
  }, [model.label]);

  return (
    <Navbar>
      <NavbarGroup
        css={css`
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        `}
      >
        <NavbarHeading>
          <Icon
            icon={
              (model.geometry &&
                (model.geometry.type === "Polygon"
                  ? "polygon-filter"
                  : model.geometry.type === "LineString"
                  ? "layout-linear"
                  : "map-marker")) ||
              "layer"
            }
            css={css`
              margin-right: 1rem;
              color: ${model.color ||
              (model.render_properties && model.render_properties.color) ||
              (model.layer &&
                model.layer.render_properties &&
                model.layer.render_properties.color)};
            `}
          />
          <CheckEditAccess
            fallback={name}
            checkLocked={model.source_id !== null}
          >
            <EditableText
              selectAllOnFocus
              confirmOnEnterKey
              disabled={!model.isEditable}
              minWidth={200}
              maxLength={32}
              value={name}
              onChange={(name) => setName(name)}
              onConfirm={(name) => {
                if (name !== model.label) {
                  updateToField("label")(name);
                }
              }}
            />
          </CheckEditAccess>
        </NavbarHeading>
        {onDelete && (
          <CheckEditAccess fallback={null} checkLocked={model.source_id !== null}>
            <div>
              <Button icon="trash" onClick={onDelete} />
            </div>
          </CheckEditAccess>
        )}
        {closeInspector && (
          <div>
            <Button icon="cross" intent="primary" onClick={closeInspector} />
          </div>
        )}
      </NavbarGroup>
    </Navbar>
  );
};

export default InspectorHeader;
